import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { DialogueHandler, AccountingSystemDialogueHandler } from './types';
import AccountingSystemContext from './AccountingSystemContext';
import { useTranslation } from 'react-i18next';

const { ConfirmationDialogue } = vp;

type AccountingSystemDialogueProps = {
  handleDialogue: DialogueHandler<AccountingSystemDialogueHandler>;
};

type FC = FunctionComponent<AccountingSystemDialogueProps>;

const AccountingSystemDialogue: FC = ({ handleDialogue }: AccountingSystemDialogueProps) => {
  const { showSyncStarted, showError, errorMessage } = useContext(AccountingSystemContext);
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.AccountingSystem.Dialogs' });

  return useMemo(
    () => (
      <div>
        {/* Sending Error Confirmation */}
        <ConfirmationDialogue
          isVisible={showError}
          title={t('SendingErrorConfirmation.title', { defaultValue: 'Error! Sync request was not completed.' })}
          status="error"
          subTitle={`${errorMessage}`}
          confirm={{
            label: t('SendingErrorConfirmation.confirmButton', { defaultValue: 'Back' }),
            action: () => handleDialogue({ type: 'error', state: 'confirm' }),
          }}
        />

        {/* Cancel Bulk Confirmation */}
        <ConfirmationDialogue
          isVisible={showSyncStarted}
          title={t('CancelBulkConfirmation.title', { defaultValue: 'Sync Has Started' })}
          status="success"
          subTitle={t('CancelBulkConfirmation.subTitle', {
            defaultValue:
              'Your accounting data is syncing to VoPay. This may take a few minutes. You can leave this page without the syncing process being interrupted.',
          })}
          confirm={{
            label: t('CancelBulkConfirmation.confirmButton', { defaultValue: 'Understood' }),
            action: () => handleDialogue({ type: 'sync', state: 'confirm' }),
          }}
        />
      </div>
    ),
    [showError, errorMessage, showSyncStarted],
  );
};

export default AccountingSystemDialogue;
